import { createSignal, onCleanup } from "solid-js";

/**
 * Reusable hook for tooltip mouse behavior with delayed hiding
 */
export const useTooltipBehavior = (hideTooltip: () => void, delay = 400) => {
  const [hideTimeout, setHideTimeout] = createSignal<number | null>(null);

  // Clear timeout on cleanup
  onCleanup(() => {
    const timeout = hideTimeout();
    if (timeout !== null) {
      clearTimeout(timeout);
    }
  });

  const handleMouseLeave = () => {
    // Set a delay before hiding
    const timeout = setTimeout(() => {
      hideTooltip();
      setHideTimeout(null);
    }, delay) as unknown as number;
    setHideTimeout(timeout);
  };

  const handleMouseEnter = () => {
    // Cancel any pending hide timeout when mouse re-enters
    const timeout = hideTimeout();
    if (timeout !== null) {
      clearTimeout(timeout);
      setHideTimeout(null);
    }
  };

  return {
    handleMouseLeave,
    handleMouseEnter,
  };
};
